import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/lunelle/Logo";
import { leaveWaitlist } from "@/lib/api";
import { usePageMeta } from "@/lib/usePageMeta";

const COPY = {
  idle: ["Leave the waitlist?", "This permanently deletes your email and faith choice from the Lunelle waitlist."],
  done: ["You've been removed.", "Your details are deleted. You won't hear from us again. You're always welcome back."],
  missing: ["Link not recognised.", "This link has already been used or is incomplete. If you're still receiving emails, contact us via the privacy policy."],
  error: ["Something went wrong.", "Please try the link again in a moment."],
};

export default function UnsubscribePage() {
  usePageMeta("Leave the waitlist | Lunelle", "Remove your email and faith choice from the Lunelle waitlist.");
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState(token ? "idle" : "missing");

  const confirm = async () => {
    setState("loading");
    try {
      const data = await leaveWaitlist(token);
      setState(data?.removed ? "done" : "missing");
    } catch {
      setState("error");
    }
  };

  const [title, text] = COPY[state] ?? COPY.idle;
  return (
    <div className="flex min-h-screen flex-col" data-testid="unsubscribe-page">
      <header className="mx-auto w-full max-w-7xl px-5 py-6 sm:px-8 lg:px-12"><Link to="/"><Logo /></Link></header>
      <main className="mx-auto flex max-w-xl flex-1 flex-col justify-center px-5 pb-24">
        <h1 className="font-serif text-5xl font-light text-[#2C221E]" data-testid="unsubscribe-title">{title}</h1>
        <p className="mt-5 text-lg leading-relaxed text-[#5C4A42]">{text}</p>
        {(state === "idle" || state === "loading") && (
          <button onClick={confirm} disabled={state === "loading"} data-testid="unsubscribe-confirm-button"
            className="mt-10 inline-flex w-fit items-center gap-2 rounded-full bg-[#9E4429] px-6 py-3 text-sm font-semibold text-[#FBF5EE] hover:bg-[#843722]">
            {state === "loading" && <Loader2 className="h-4 w-4 animate-spin" />} Yes, remove me
          </button>
        )}
        <Link to="/" className="mt-6 text-sm text-[#6B5A52] underline-offset-4 hover:underline" data-testid="unsubscribe-home-link">Back to Lunelle</Link>
      </main>
    </div>
  );
}
